import ReactGA from 'react-ga4';

export function captureGoogleAnalyticsEvent(
	category: string,
	action: string,
	value?: number | null,
) {
	ReactGA.event({
		category,
		action,
		value, // optional, must be a number
	});
}
